import camelCase from 'lodash/camelCase';

export function camelCaseObjectKeys(obj) {
    if (Array.isArray(obj)) {
        return obj.map(item => camelCaseObjectKeys(item));
    } else if (obj !== null && typeof obj === 'object') {
        return Object.entries(obj).reduce((acc, [key, value]) => {
            acc[camelCase(key)] = camelCaseObjectKeys(value);
            return acc;
        }, {});
    }
    return obj; // Return the value directly if it's not an object or array
}

